"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterButton = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _logger = require("../../logger");
var _utils = require("../../utils");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const componentName = 'FilterButton.tsx';
const Root = (0, _mui.styled)('span')((param)=>{
    let { theme } = param;
    return {
        alignItems: 'center',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'row',
        gap: theme.spacing(1)
    };
});
const FilterButton = (param)=>{
    let { defaultValue, filters, id, isLabelVisible, label, menuProps, onFilterChange, value, ...restOfRootProps } = param;
    const [anchorElement, setAnchorElement] = (0, _react.useState)(undefined);
    const isOpen = Boolean(anchorElement);
    const handleClick = (0, _react.useCallback)((event)=>{
        (0, _logger.logDebug)("".concat(componentName, ": handleClick()"));
        setAnchorElement(event.currentTarget);
    }, [
        setAnchorElement
    ]);
    const handleClose = (0, _react.useCallback)(()=>{
        (0, _logger.logDebug)("".concat(componentName, ": handleClose()"));
        setAnchorElement(undefined);
    }, [
        setAnchorElement
    ]);
    const elementId = id ? "".concat(id, "-popup") : undefined;
    (0, _logger.logDebug)("Rendering ".concat(componentName, " ...\n	"), {
        value,
        defaultValue,
        anchorElement,
        isOpen,
        elementId
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(Root, {
                "aria-haspopup": true,
                "aria-controls": isOpen ? elementId : undefined,
                "aria-label": label,
                "aria-expanded": isOpen ? true : undefined,
                id: id,
                role: "button",
                tabIndex: 0,
                onClick: handleClick,
                ...restOfRootProps,
                children: [
                    isLabelVisible && Boolean(label) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                        variant: "caption",
                        children: label
                    }) : null,
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Badge, {
                        color: "primary",
                        invisible: value === defaultValue,
                        overlap: "circular",
                        variant: "dot",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Filter, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Menu, {
                ...menuProps,
                anchorEl: anchorElement,
                open: isOpen,
                anchorOrigin: {
                    horizontal: 'right',
                    vertical: 'bottom'
                },
                transformOrigin: {
                    horizontal: 'right',
                    vertical: 'top'
                },
                classes: {
                    list: 'OriSelectList',
                    paper: 'OriSelectPaper'
                },
                slotProps: {
                    paper: {
                        elevation: 0
                    }
                },
                id: elementId,
                MenuListProps: {
                    'aria-labelledby': elementId
                },
                onClose: handleClose,
                children: filters.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.MenuItem, {
                        role: "option",
                        selected: option === value,
                        value: option,
                        "aria-selected": option === value,
                        onClick: ()=>{
                            (0, _logger.logInfo)("".concat(componentName, ": Filter item with value '").concat(option, "' was selected."));
                            handleClose();
                            onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(option);
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                            id: (0, _utils.getFilterTranslationKey)(option)
                        })
                    }, option))
            })
        ]
    });
};
exports.FilterButton = FilterButton;
